import {Audit} from "./Audit";

interface AuditGroupProps {
  title: string;
  audits: unknown[];
}

export const AuditGroup = ({title, audits}: AuditGroupProps) => {
  // @ts-expect-error mute type mismatch since we don't know the type
  const items = audits.map((audit) => <Audit key={audit.id} audit={audit} />);
  return (
    <div key={title}>
      {title != "" && <h5>{title}</h5>}
      <div>{items}</div>
    </div>
  );
};
